import {
    getPayers,
    addPayer,
    editPayer,
    deletePayer,
    changeStatus,
    /** Connect Momentm to Payer */
        getMomentmToPayer,
    connectMomentmToPayer,
    editMomentmToPayer,
    editMomentmStatus,
    /** End */

    /** Payer Rates */
    getPayerRates,
    editPayerRate,
    deletePayerRate,
    addPayerRate,
    getPayerSingle,
    enablePayerApptTime,
    editPayerTimeRules,
} from "./payer.action";

export {payerReducer} from "./payer.reducer";
export {watchPayer} from "./payer.saga";

export const payerActions = {
    /** Payers */
    getPayers,
    getPayerSingle,
    addPayer,
    editPayer,
    deletePayer,
    changeStatus,
    /** Connect Momentm to Payer */
    getMomentmToPayer,
    connectMomentmToPayer,
    editMomentmToPayer,
    editMomentmStatus,
    /** End */

    /** Payer Rates */
    getPayerRates,
    editPayerRate,
    deletePayerRate,
    addPayerRate,

    /** Appt Time Rules*/
    editPayerTimeRules,
    enablePayerApptTime,
};
